import { render, staticRenderFns } from "./importar.vue?vue&type=template&id=4bf29d4e&"
import script from "./importar.vue?vue&type=script&lang=js&"
export * from "./importar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports